<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div v-if="quizInfo.quizDetails.isGraded" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score:</p>
        <p>{{ quizAchievedMarks + " / " +  (quizInfo.quizTotal + quizTextTotal) }}</p>
      </div>
    </div>
    <div v-if="quizInfo.finalAssessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>Assessor Final Comment:</strong></label>
        <vs-textarea readOnly v-model="quizInfo.finalAssessorComment" />
      </div>
    </div>
    <div v-if="!viewOnly" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Final Comment:</label>
        <vs-textarea v-model="quizInfo.finalStudentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizAchievedMarks: {
        type: Number,
        required: false
      },
      quizTextTotal: {
        type: Number,
        required: false
      },
      quizInfo: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
